<template>
	<div class="box" v-loading="loading" :element-loading-text="$t('bc.bc_50')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="signup">
			{{$t('ResetPassword.ResetPassword_lbl0')}}
		</div>
		<div class="signup2">
			{{$t('ResetPassword.ResetPassword_lbl1')}}
		</div>
		<el-row style="margin-top: 20px;">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" label-position="left">
				<el-row>
					<el-col :span="24">
						<el-form-item :label="$t('ResetPassword.ResetPassword_lbl2')"  prop="userid">
							<el-input v-model="ruleForm.userid" style="width: 90%;" placeholder="user@mrhiro.co.jp">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="18">
						<el-form-item :label="$t('ResetPassword.ResetPassword_lbl3')"  prop="code">
							<el-input v-model="ruleForm.code" style="width: 90%;"
								onkeyup="this.value=this.value.replace(/[^\d]/g,'') " maxlength="5" placeholder="CODE">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6" style="" @click="sendCode" class="code">
						<span v-if="sendconfirm" @click="sendCode">{{codemsg}}</span>
						<span v-else>{{codemsg}}</span>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="18" :xs="24" :sm="18" :md="18" :xl="18" :lg="18" >
						<el-form-item :label="$t('ResetPassword.ResetPassword_lbl7')" 
							prop="password">
							<el-input v-model="ruleForm.password" type='password' style="width: 90%;"
								placeholder="PASSWORD"></el-input>
						</el-form-item>
					</el-col>
				</el-row>


				<el-row  class="pwdbox">
					<el-col :span="24" class="pwdmsg">
						{{$t('ResetPassword.ResetPassword_lbl5')}}
					</el-col>
				</el-row>
				<el-row style="text-align: center; margin-top: 10px;">
					<el-col :span="24">
						<el-button class="resetbtn" @click="submitReset"> {{$t('ResetPassword.ResetPassword_lbl6')}}
						</el-button>
					</el-col>
				</el-row>
			</el-form>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'Login',
		inject: ['reload'],
		data() {
			// 验证码证规则
			const validateVerifycode = (rule, value, callback) => {
				if (value == '') {
					callback(new Error(this.$t('Register.Register_lbl14'))); //请输入验证码
				} else if (value.length != 5) {
					callback(new Error(this.$t('bc.bc_40')));
				} else {
					callback();
				}
			}

			const validateEmail = (rule, value, callback) => { //请输入账号
				if (value === '') {
					callback(new Error(this.$t('Register.Register_lbl12')));
				}
				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				let isok = reg.test(value);
				console.log(isok)
				if (!isok) {
					callback(new Error(this.$t('Register.Register_lbl13')));
				} else {
					callback();
				}
			};

			const validatePwd = (rule, value, callback) => { //请输入密码
				var res = (/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,18}$/)
				if (value === '') {
					callback(new Error(this.$t('Register.Register_lbl15')));
				} else if (!res.test(value)) {
					callback(new Error(this.$t('bc.bc_9')));
				} else {
					callback();
				}
			};
			return {
				getcode: '',
				loading: false,
				lang: 0,

				ruleForm: {
					userid: '',
					code: '',
					password: '',
				},
				codemsg: '',
				sendconfirm: true,
				timer: null,
				count: "",

				rules: {
					userid: [{ //提示请输入手机号
						trigger: ['blur', 'change'],
						validator: validateEmail
					}],
					password: [{ //提示请输入密码
						trigger: ['blur', 'change'],
						validator: validatePwd
					}],
					code: [{ //提示清输入验证码
						trigger: ['blur', 'change'],
						validator: validateVerifycode
					}],
				},
			}
		},
		created() {
			this.codemsg = this.$t('ResetPassword.ResetPassword_lbl4');		
		},
		mounted() {
			this.$on('closeReset', function() {
				this.closeReset();
			});
		},
		methods: {
			// submitReset(){
			// 	this.$emit('submitReset');
			// },

			submitReset() {
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				let myDate = new Date();
				let yy = myDate.getFullYear()
				let mm = myDate.getMonth() + 1 < 10 ? '0' + myDate.getMonth() + 1 : myDate.getMonth() + 1;
				let dd = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				let hh = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
				let ff = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
				let stime = yy + '年' + mm + '月' + dd + '日' + ' ' + hh + ':' + ff
				console.log(stime)
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						if (this.getcode == this.ruleForm.code) {
							this.loading = true
							this.$api.post(this.$config.Upd_Pwd, {
									// 'YHSEQNUM': localStorage.getItem('YHSEQNUM')
									'sEMAIL': this.ruleForm.userid,
									'sPassword': this.ruleForm.password,
									'sTIME': stime,
									'sLNGCT': this.lang
								},
								// 请求成功
								success => {
									this.loading = false
									console.log(success)
									if (success.KKSTR == 'Y') {
										this.$emit('submitReset')
										this.reload();
										this.$message.success(this.$t('Register.Register_lbl24'));
									} else if (success.KKSTR == 'N') {
										this.$message({
											message: this.$t('Register.Register_lbl25'), //该账号已经注册
											type: 'error'
										});
									} else if (success.KKSTR == 'E') {
										this.$message({
											message: this.$t('bc.bc_24'), //该账号已经注册
											type: 'error'
										});
									}
								},
								// 请求失败
								error => {
									this.loading = false
									console.log(error)
									console.log("_________我的收藏error")
								}
							)
						} else {
							this.loading = false
							this.$message({
								message: this.$t('bc.bc_53'), //验证码错误
								type: 'error'
							});

						}
					} else {
						this.loading = false
						this.$message({
							message: this.$t('bc.bc_37'), //请求失败
							type: 'error'
						});
					}
				});
			},
			closeReset() {

				clearInterval(this.timer);
				this.timer = null;
				this.sendconfirm = true;
				this.codemsg = this.$t('ResetPassword.ResetPassword_lbl4');
				this.ruleForm.userid = ''
				this.ruleForm.code = ''
				this.ruleForm.password = ''
			},

			sendCode() {
				let myDate = new Date();
				let yy = myDate.getFullYear()
				let mm = myDate.getMonth() + 1 < 10 ? '0' + myDate.getMonth() + 1 : myDate.getMonth() + 1;
				let dd = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				let hh = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
				let ff = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
				let stime = yy + '年' + mm + '月' + dd + '日' + ' ' + hh + ':' + ff
				if (this.ruleForm.userid) {

					this.loading = true
					let curCount = 0;
					let TIME_COUNT = 60;
					if (this.$i18n.locale == 'ja') {
						this.lang = 0
					}
					else if (this.$i18n.locale == 'zh') {
						this.lang = 1
					}
					else if (this.$i18n.locale == 'en') {
						this.lang = 2
					}

					this.$api.post(this.$config.Get_Upd_Code, {
							'sTIME': stime,
							'sEMAIL': this.ruleForm.userid,
							'sLNGCT': this.lang
						},
						// 请求成功
						success => {
							this.loading = false
							console.log(success)
							if (success.KKSTR == 'N') {
								this.$message({
									message: this.$t('Register.Register_lbl29'), //该账号已经注册
									type: 'error'
								});
							} else if (success.KKSTR == 'E') {
								this.$message({
									message: this.$t('bc.bc_24'), //该账号已经注册
									type: 'error'
								});
							} else {
								if (!this.timer) {
									this.count = TIME_COUNT;
									this.timer = setInterval(() => {
										if (this.count > 0 && this.count <= TIME_COUNT) {
											curCount = this.count--;
											this.codemsg = curCount + "s";
											this.sendconfirm = false;
										} else {
											this.sendconfirm = true;
											this.codemsg = this.$t('ResetPassword.ResetPassword_lbl4');
											clearInterval(this.timer);
											this.timer = null;
										}
									}, 1000);
								}
								this.$message({
									message: this.$t('bc.bc_46'),
									type: 'success'
								});
								this.getcode = success.KKSTR
							}
						},
						// 请求失败
						error => {
							this.loading = false
							console.log(error)
						}
					)
				} else {
					this.loading = false
					this.$message({
						message: this.$t('Register.Register_lbl12'), //账号或密码错误
						type: 'error'
					});
				}
			},
			toRefresh() {
				this.$refs['ruleForm'].resetFields();
			}
		}
	}
</script>

<style scoped>
	@media only screen and (min-width:680px) {
	
	.signup {
		text-align: center;
		font-size: 50px;
		font-family: Roboto-Bold, Roboto;
		font-weight: bold;
		color: #000000;
	}}

	@media only screen and (max-width:680px) {
	
	.signup {
		text-align: center;
		font-size: 30px;
		font-family: Roboto-Bold, Roboto;
		font-weight: bold;
		color: #000000;
	}}
	.box {
		width: 100%;
		height: 100%;

	}


	.signup2 {
		margin-top: 10px;
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
		text-align: center;
	}

	.pwdmsg {

		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #FF0000;
		line-height: 15px;
	}

	.resetbtn {
		width: 270px;
		height: 50px;
		background: #000000;
		border-color: #000000;
		font-size: 18px;
		font-family: Noto Sans CJK JP-Black, Noto Sans CJK JP;
		font-weight: 900;
		color: #FFFFFF;
		margin-top: 40px;

	}

	/deep/ .el-form-item__label {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
		padding: 7px 0;
		line-height: 26px;

	}

	.code {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #FE9C2C;
		cursor: pointer;
		text-decoration: underline;
	}
	
	
	.pwdbox{
		
		margin-left: 130px;
	}
	
	
	@media only screen and (max-width:680px) {
		
		
		.pwdbox{
			
			margin-left: 0px;
		}
		
		/deep/
		.el-form-item__error{
			font-size: 10px;
		}
	}
	
</style>
